var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-setting-container"},[_c('PromotionPoint',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }